import { SentryEnvironment } from './environment.sentry';
import { BuildEnvironment } from './typings';

export const environment: BuildEnvironment = {
  SENTRY_RELEASE: SentryEnvironment.SENTRY_RELEASE,
  SENTRY_DSN: SentryEnvironment.SENTRY_DSN,
  name: 'beta',
  production: false,
};
